export const BusinessErrorCode = {
  BusinessNotFound: 'BusinessNotFound',
  BusinessProfileNotFound: 'BusinessProfileNotFound',
  BusinessAlreadyExists: 'BusinessAlreadyExists',
  UserAlreadyHasBusiness: 'UserAlreadyHasBusiness',
  AdminRequiresBusinessId: 'AdminRequiresBusinessId',
  InsufficientCredits: 'InsufficientCredits',
} as const
export type BusinessErrorCode = (typeof BusinessErrorCode)[keyof typeof BusinessErrorCode]
